export default function Keys() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="ic-carkey">
        <path
          id="Vector"
          d="M12.2175 6.62737L6.03086 4.99659C4.96278 4.71505 3.86869 5.35267 3.58715 6.42076L0.820582 16.9163C0.53904 17.9843 1.17666 19.0784 2.24475 19.36L8.43142 20.9908C9.49951 21.2723 10.5936 20.6347 10.8751 19.5666L13.6417 9.07109C13.9232 8.00301 13.2856 6.90892 12.2175 6.62737Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M7.79904 13.0678C9.02954 13.0678 10.027 12.0703 10.027 10.8398C10.027 9.60933 9.02954 8.61182 7.79904 8.61182C6.56855 8.61182 5.57104 9.60933 5.57104 10.8398C5.57104 12.0703 6.56855 13.0678 7.79904 13.0678Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M4.68005 15.3901C4.77603 15.4157 4.85798 15.4783 4.90801 15.5641C4.95803 15.6499 4.97207 15.752 4.94705 15.8481"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M4.22095 15.6568C4.24653 15.5606 4.30921 15.4785 4.39526 15.4284C4.4813 15.3784 4.58368 15.3645 4.67995 15.3898"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M4.48798 16.1152C4.39201 16.0896 4.31006 16.0271 4.26003 15.9413C4.21 15.8555 4.19597 15.7534 4.22098 15.6572"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M4.94704 15.8481C4.93449 15.8958 4.91265 15.9406 4.88277 15.9799C4.8529 16.0191 4.81557 16.0521 4.77293 16.0769C4.7303 16.1017 4.68319 16.1178 4.6343 16.1244C4.58541 16.131 4.53571 16.1278 4.48804 16.1151"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_7"
          d="M8.27002 16.3369C8.31768 16.3494 8.36242 16.3711 8.40166 16.4009C8.4409 16.4306 8.47388 16.4679 8.49869 16.5104C8.5235 16.553 8.53965 16.6 8.54623 16.6488C8.55281 16.6977 8.54968 16.7473 8.53702 16.7949"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_8"
          d="M7.81201 16.6001C7.83737 16.504 7.89986 16.4219 7.98574 16.3718C8.07162 16.3218 8.17387 16.3078 8.27001 16.3331"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_9"
          d="M8.07902 17.062C7.9829 17.0366 7.90078 16.9742 7.85072 16.8883C7.80065 16.8024 7.78673 16.7001 7.81202 16.604"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_10"
          d="M8.53698 16.7998C8.51162 16.8959 8.44913 16.978 8.36325 17.0281C8.27737 17.0782 8.17512 17.0921 8.07898 17.0668"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_11"
          d="M17.309 11.11C17.3017 10.7153 17.3732 10.3231 17.5192 9.9564C17.6653 9.58966 17.8829 9.25569 18.1595 8.97402C18.436 8.69234 18.7659 8.4686 19.1299 8.31587C19.4939 8.16314 19.8847 8.08447 20.2795 8.08447C20.6742 8.08447 21.065 8.16314 21.429 8.31587C21.793 8.4686 22.1229 8.69234 22.3995 8.97402C22.676 9.25569 22.8937 9.58966 23.0397 9.9564C23.1857 10.3231 23.2572 10.7153 23.25 11.11V13.338C23.25 13.7318 23.0935 14.1095 22.815 14.388C22.5365 14.6665 22.1588 14.823 21.765 14.823H18.794C18.4001 14.823 18.0224 14.6665 17.7439 14.388C17.4654 14.1095 17.309 13.7318 17.309 13.338V11.11Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_12"
          d="M21.7649 20.7652L20.2789 22.2502L18.7939 20.7652V14.8232H21.7649V20.7652Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_13"
          d="M9.12402 5.81301C10.9 1.10901 19.1 -0.772986 20.279 8.13901"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
